export const MAILCHIMP_FORM_ACTION =
  process.env.REACT_APP_MAILCHIMP_FORM_ACTION;
export const MAILCHIMP_USER_ID = process.env.REACT_APP_MAILCHIMP_USER_ID;
export const MAILCHIMP_AUDIENCE_ID =
  process.env.REACT_APP_MAILCHIMP_AUDIENCE_ID;
export const MAILCHIMP_FORM_ID = process.env.REACT_APP_MAILCHIMP_FORM_ID;
export const MAILCHIMP_HONEYPOT_FIELD =
  process.env.REACT_APP_MAILCHIMP_HONEYPOT_FIELD;
export const MAILCHIMP_SUBSCRIBE_VALUE = "Subscribe";
export const STORAGE_KEY = "userWaitListEmail";
export const MAILCHIMP_CARD_TAG_ID = "246";

export const MERGE_TAGS = {
  NAME: "FNAME",
  CITIZENSHIP: "CITIZEN",
  RESIDENCE: "COUNTRY",
};
